import './Footer.css'

const Footer = () => {
  return (
    <footer className='footer'>
      <a
        href='https://github.com/ShujaatAzim/shujaatazim.github.io'
        target='_blank'
        className='link footer__link'
      >
        Created By Shujaat Azim
      </a>
    </footer>
  );
}

export default Footer